import { render } from "./entity-selection.vue?vue&type=template&id=c5887dc4&ts=true"
import script from "./entity-selection.ts?vue&type=script&lang=ts&external"
export * from "./entity-selection.ts?vue&type=script&lang=ts&external"

import "./entity-selection.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__